import { makeSchedulable, makeTimeAllocable, SchedulablesController }   from "./schedulable_helpers";

export default makeTimeAllocable(makeSchedulable(class extends SchedulablesController {
  static targets = ["form", "all", "repeatUpdatePrompt"];

  connect() {
    this.preConnect && this.preConnect();
    this.submitForm           = this.submitForm.bind(this);
    this.submitSuccessHandler = this.submitSuccessHandler.bind(this);
    this.submitErrorHandler   = this.submitErrorHandler.bind(this);
    this.closeAllocationForm  = this.closeAllocationForm.bind(this);
    App.Helpers.listenToCustomEvent(document, "schedulables:submit-repeat-action", this.submitForm);
    App.Helpers.addAjaxHandlers(this.formTarget, this.submitSuccessHandler, this.submitErrorHandler);
  }

  showRepeatUpdatePrompt(event) {
    event && event.preventDefault && event.preventDefault();
  }

  closeAllocationForm(event) {
    event && event.preventDefault && event.preventDefault();
    this.getTimeAllocContainerFrom(this.timeAllocationURL);
  };

  submitForm(event) {
    if (event.detail.actionType == "edit") {
      this.allTarget.value = event.detail.all;
      App.Helpers.submitRemoteForm(this.formTarget);
    }
  }

  submitSuccessHandler(event, response) {
    const { new_url: newURL } = response;
    newURL ? App.Helpers.goToLocation(newURL) : this.closeAllocationForm();
  }

  submitErrorHandler(event, data) {
    this.element.replaceWith(data.responseText);
  }
}));



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-time-allocation-edit-controller.js